<template>
  <span>
    <v-dialog v-model="dialog" width="600">
      <template v-slot:activator="{ on }">
        <v-btn @click="searchStandards" icon v-on="on">
          <v-icon>mdi-alpha-s-circle-outline</v-icon>
        </v-btn>
      </template>

      <v-card width="100%" class="mx-auto">
        <v-toolbar :loading="isAppLoading">
          <v-toolbar-title>Search Standards</v-toolbar-title>
          <v-btn class="ml-auto" icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        
        <v-toolbar v-if="collapseSearch" collapse dense>
          <v-spacer />Search
          <v-btn @click="collapseSearch = !collapseSearch" icon>
            <v-icon>mdi-export</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text v-else>
          <v-row >
            <v-col cols="12" lg="6">
              <v-select
                lg6
                v-model="selectedGrade"
                :items="grades"
                item-text="name"
                item-value="value"
                label="Grade"
                clearable
              />
            </v-col>
            <v-col cols="12" lg="6">
              <v-select clearable lg6 v-model="selectedSubject" :items="subjects" label="Subject" />
            </v-col>
            <v-col cols="12">
              <v-btn @click="searchStandards">Search</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        
        <v-card class="mt-5">
          <v-card-title>
            Selected {{selectedResults.length}}
            <v-spacer/>
            <v-btn v-if="selectedResults.length && selectedResults.length > 0" @click="addStandard">Add</v-btn>
          </v-card-title>
          <v-card-text v-if="selectedResults.length > 0">
            <v-chip
              class="ml-2 mb-2"
              v-for=" (s) in selectedResults"
              :key="s.id"
              :close="true"
              outlined
              @click:close="s.selected = false"
            >{{s.standardCode}}</v-chip>
          </v-card-text>
          
          <v-card-text v-if="pagedResult && pagedResult.length > 0">
            <v-select
              v-model="domain"
              clearable
              label="Filter by Domain"
              :items="domains"
              item-value="code"
              item-text="name"
            />
            <span class="mb-2">Found {{searchResults.length}} matching results:</span>
            <v-expansion-panels multiple>
              <v-expansion-panel v-for=" (s) in pagedResult" :key="s.id">
                <v-expansion-panel-header>
                  <v-checkbox
                    dense
                    v-model="s.selected"
                    @click.native="check($event)"
                    :label="`${s.standardCode} - ${s.subCategory}`"
                  ></v-checkbox>
                </v-expansion-panel-header>
                <v-expansion-panel-content>{{s.standardDescription}}</v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card-text>

          <v-pagination
            v-if="pageLength > 1"
            v-model="page"
            :length="pageLength"
            circle
            :total-visible="6"
          ></v-pagination>
        </v-card>

      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  props: ["grade", "subject", "searchTerms", "results"],
  data() {
    return {
      dialog: false,
      page: 1,
      pageLength: 0,
      pageSize: 10,
      searchResults: [],
      term: "",
      selectedGrade: null,
      selectedSubject: null,
      collapseSearch: false,
      domain: null,
      filteredResults: []
    };
  },
  watch: {
    dialog(show) {
      if (show) {
        this.openDialog();
      }
    },
    domain(newDomain) {
      this.filterResults(newDomain);
    }
  },
  computed: {
    ...mapGetters(["grades", "subjects", "isAppLoading"]),
    pagedResult() {
      const start = (this.page - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.filteredResults.slice(start, end);
    },
    selectedResults() {
      return this.searchResults.filter(r => r.selected);
    },
    domains() {
      return [
        ...new Set(
          this.searchResults.map(s => {
            return { code: s.categoryCode, name: s.categoryName };
          })
        )
      ];
    }
  },
  methods: {
    ...mapActions(["addErrorMessage", "addMessage"]),
    searchStandards() {
      if (!this.selectedGrade && !this.selectedSubject) {
        this.addMessage("Please choose a grade or subject to search");
        return;
      }

      this.page = 1;
      this.domain = null; //reset filter
      const data = {
        // searchTerm: this.term,
        filterTerm: {
          STANDARD: [
            {
              name: "subject",
              value: this.selectedSubject
            },
            {
              name: "grade",
              value: this.selectedGrade
            }
          ]
        },
        searchEntities: ["STANDARD"],
        pageSize: this.pageSize
      };
      this.$axios
        .post("search", data)
        .then(resp => {
          // console.log(resp.data.standards);
          this.searchResults = resp.data.standards || [];

          if (this.searchResults.length > 0) {
            this.collapseSearch = true;

            this.filterResults(this.domain);
          }
        })
        .catch(resp => {
          this.$store.dispatch(
            "addErrorMessage",
            resp.data.message || resp.data
          );
        });
    },
    filterResults(domainCode) {
      console.log("filtering results using domain " + domainCode);
      if (this.searchResults) {
        if (domainCode) {
          this.filteredResults = this.searchResults.filter(
            r => domainCode == r.categoryCode
          );
        } else {
          this.filteredResults = this.searchResults;
        }

        this.pageLength =
          Math.ceil(this.filteredResults.length / this.pageSize) || 0;
      }
    },
    openDialog(event) {
      this.$emit("onOpen", event);
    },
    addStandard(event) {
      // const ccStandardIds = this.selectedResults.map(r => r.id);
      this.$emit("addedStandards", event, this.selectedResults);

      this.dialog = false;
      // will run after $emit is done
      // this.$nextTick(() => {
      //   this.menu = false;
      // });
    },
    check: function(e) {
      e.cancelBubble = true;
    }
  },
  mounted() {
    this.term = this.searchTerms;
    this.selectedGrade = this.grade;
    this.selectedSubject = this.subject;
  }
};
</script>